module.exports = __webpack_public_path__ + "static/img/dongtaifudai.61b7aa1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dongtaifudai.gif
// module id = kU4X
// module chunks = 128